<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot"><span class="epub-i">In human intimacy there is a secret barrier: neither the experience of being in love, nor that of passion, can traverse it, even if lips are joined together in terrible silence and the heart breaks to pieces with love.</span></p>
<p class="epc-bot"><span class="epub-sc">ANNA AKHMATOVA</span></p>
<p class="ep-bot"><span class="epub-i">This is my letter to the World<br/>That never wrote to Me</span>—</p>
<p class="epc"><span class="epub-sc">EMILY DICKINSON</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraphs.vue?77588559